import { Extension } from '@tiptap/core';
import { BackgroundColor } from '../background-color';
import { Color } from '../color';
import { FontFamily } from '../font-family';
import { FontSize } from '../font-size';
import { LineHeight } from '../line-height';
import { TextStyle } from '../main';
/**
 * The table kit is a collection of table editor extensions.
 *
 * It’s a good starting point for building your own table in Tiptap.
 */
export const TextStyleKit = Extension.create({
    name: 'textStyleKit',
    addExtensions() {
        const extensions = [];
        if (this.options.backgroundColor !== false) {
            extensions.push(BackgroundColor.configure(this.options.backgroundColor));
        }
        if (this.options.color !== false) {
            extensions.push(Color.configure(this.options.color));
        }
        if (this.options.fontFamily !== false) {
            extensions.push(FontFamily.configure(this.options.fontFamily));
        }
        if (this.options.fontSize !== false) {
            extensions.push(FontSize.configure(this.options.fontSize));
        }
        if (this.options.lineHeight !== false) {
            extensions.push(LineHeight.configure(this.options.lineHeight));
        }
        if (this.options.textStyle !== false) {
            extensions.push(TextStyle.configure(this.options.textStyle));
        }
        return extensions;
    },
});
